export const SITESETUP_CLEAR_FETCHED = 'SITESETUP_CLEAR_FETCHED';



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/types.js